import theme from "../../../style/theme";
// import { OutlineRoutePinProps } from "../../../types/Pin/outline-route-pin";
import { OutlineRoutePin } from "./OutlineRoutePin";
import { OutlineRoutePinProps } from "./outline-route-pin-props";

export const YellowOutlineRoutePin: React.FC<OutlineRoutePinProps> = ({
  number,
  rightLabel,
  leftLabel,
}) => {
  return (
    <OutlineRoutePin
      backgroundColor={theme.palette.primitives["yellow400"]}
      borderColor={theme.palette.primitives["yellow50"]}
      color={theme.palette.primitives["gray900"]}
      borderWidth={1}
      number={number}
      rightLabel={rightLabel}
      leftLabel={leftLabel}
    />
  );
};
